import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { InputContextValues } from '../../context/InputContext';
import { useNumberOfToggle } from '../../hooks/useNumberOfToggle';
import useCheckMobileScreen from '../../hooks/useWidth';
import { HandleChangeVisible, IFormField } from '../../schema/interface';
import InputContainer from '../InputContainer';

const styles = createUseStyles({
    groupContainer: {
        boxShadow: 'rgb(35 39 51 / 10%) 0px 2px 8px 0px',
        border: '1.5px solid rgb(233, 238, 242)',
        borderRadius: '6px',
        marginBottom: '20px',
        width: '100%'
    },
    fieldItem: ({ isToggle, column, isSmallMobile, isLongField }) => ({
        minWidth:
            isToggle && column === 1 && !isSmallMobile
                ? '50%'
                : isToggle || isLongField
                ? '100%'
                : 'max(48.4%, 310px)'
    })
});
interface IGroupItem {
    field: IFormField;
    uploadMedia: Function;
    handleChangeVisible: HandleChangeVisible;
    noAccess?: boolean;
    index: number;
    formStructure: IFormField[];
}
const GroupItem = ({
    field,
    formStructure,
    handleChangeVisible,
    noAccess,
    index,
    uploadMedia
}: IGroupItem) => {
    const { isToggle, column } = useNumberOfToggle({ field });
    const { smallSize: isSmallMobile } = useCheckMobileScreen(556);
    const { formValues } = useContext(InputContextValues);
    const isLongField = field?.data_type === 'text';

    const classes = styles({ isToggle, column, isSmallMobile, isLongField });
    return (
        <div className={field?.data_type === 'group' ? classes.groupContainer : classes.fieldItem}>
            <InputContainer
                field={field}
                value={(formValues && formValues[field.name]) || ''}
                uploadMedia={uploadMedia}
                prevField={index > 0 ? formStructure.fields[index - 1] : null}
                handleChangeVisible={handleChangeVisible}
                formValues={formValues}
                noAccess={noAccess}
            />
        </div>
    );
};

export default GroupItem;
